import script from "./InvoicesView.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoicesView.vue?vue&type=script&setup=true&lang=js"

import "./InvoicesView.vue?vue&type=style&index=0&id=c4fe1536&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c4fe1536"]])

export default __exports__